(() => {
  function moneyToNumber(text) {
    if (!text) return 0;

    const value = text
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    return parseFloat(value) || 0;
  }

  function decorateSales(root = document) {
    const cards = [];
    if (root instanceof Element && root.matches('.card, .product-card, [class*="product-card"]')) cards.push(root);
    if (root.querySelectorAll) cards.push(...root.querySelectorAll('.card, .product-card, [class*="product-card"]'));

    [...new Set(cards)].forEach((card) => {
      const compare = card.querySelector('s, del, .price-item--regular, [class*="compare"]');
      const sale = card.querySelector('.price-item--sale, [class*="sale-price"]');

      card.querySelectorAll('.margalo-sale-label').forEach((el) => el.remove());
      if (!compare || !sale) return;

      const comparePrice = moneyToNumber(compare.textContent);
      const salePrice = moneyToNumber(sale.textContent);
      if (comparePrice <= salePrice || salePrice <= 0) return;

      const badge = document.createElement('span');
      badge.className = 'margalo-sale-label';
      badge.textContent = 'SALE';
      (card.querySelector('.price, [class*="price"]') || card).prepend(badge);
    });
  }

  let raf = 0;
  const pendingRoots = new Set();
  function schedule(root = document) {
    pendingRoots.add(root);
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      pendingRoots.forEach((node) => decorateSales(node));
      pendingRoots.clear();
    });
  }

  function init() {
    decorateSales(document);

    // Observe only newly inserted content that could contain product cards.
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            node.matches('.card, .product-card, [class*="product-card"]') ||
            node.querySelector('.card, .product-card, [class*="product-card"]')
          ) {
            schedule(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
